import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum NOTIFICATION_TYPE {
  HIDDEN = 'hidden',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
}

interface BaseEvent {
  type: NOTIFICATION_TYPE;
  title?: string;
}

export interface EmptyNotificationEvent extends BaseEvent {
  type: NOTIFICATION_TYPE.HIDDEN;
}

export interface TriggerEvent extends BaseEvent {
  type: Exclude<NOTIFICATION_TYPE, NOTIFICATION_TYPE.HIDDEN>;
  messages: string[];
}

export type NotificationEvent = EmptyNotificationEvent | TriggerEvent;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private readonly listeners: Subject<NotificationEvent>;

  constructor() {
    this.listeners = new Subject<NotificationEvent>();
  }

  register(): Subject<NotificationEvent> {
    return this.listeners;
  }

  clearNotifications(): void {
    this.listeners.next({
      type: NOTIFICATION_TYPE.HIDDEN,
    });
  }

  notify(event: TriggerEvent): void {
    this.listeners.next(event);
  }
}
